import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-guide-close",
  "use": "icon-ic-guide-close-usage",
  "viewBox": "0 0 17 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 18\" id=\"icon-ic-guide-close\"><path d=\"M1.417 9a7.083 7.083 0 1 1 14.166 0A7.083 7.083 0 0 1 1.417 9Z\" fill=\"#B2B6C0\" /><path d=\"M6.163 6.078a.413.413 0 1 0-.585.584L7.916 9l-2.338 2.337a.413.413 0 0 0 .585.585L8.5 9.584l2.337 2.338a.413.413 0 0 0 .585-.585L9.084 9l2.338-2.338a.413.413 0 0 0-.585-.584L8.5 8.415 6.163 6.078Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol